<template>
  <div class="CorporationG">
    <PageContent>
      <StepsV2 type="s3" :step="1" />
      <PanelV2
        type="w6"
        title="List down your authorized signatories"
        @nextClick="commitData"
      >
        <template v-slot:title-solt>
          <BdoProgress total="4" step="4" />
        </template>
        <template v-slot:content-solt>
          <Signatory ref="appForm" />
        </template>
      </PanelV2>
    </PageContent>
  </div>
</template>

<script>
  import API from "@/api";
  import Signatory from "../components/Signatory"
  export default {
    name: 'PartnershipG',
    pRouter: 'PartnershipF',
    components: {
      Signatory,
    },
    data() {
      return {
        formData: {},
      }
    },
    methods: {
      commitData() {
        this.$refs.appForm.$refs.formData.validate((valid) => {
          if (valid) {
            const formData = this.$refs.appForm.formData.formArr
            const data = this.formatCommitData({businessauthorized:formData})
            API.addBdoProcess({
              ...data
            }).then((res) => {
              if (res.success === true) {
                this.toNext();
              }
            });
          }
        });
      },
    }
  }
</script>


<style lang="scss" scoped>
.CorporationG {
  .content > div {
    width: 100%;
    min-height: 292px;
  }
}
</style>
